"use strict";

var _useClientPreferences_ClientPreferences;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getEnvironment } from '@autoguru/relay';
import { useEffect, useMemo } from 'react';
import { commitLocalUpdate } from 'react-relay';
import { graphql, useFragment } from 'react-relay/hooks';
export const getDiscardedItemId = id => `DISCARDED_${id}`;
export const useClientPreferences = ({
  clientPreferences: clientPreferencesRef,
  clientPersistedPreferences,
  viewerId
}) => {
  const prefs = useFragment(_useClientPreferences_ClientPreferences !== void 0 ? _useClientPreferences_ClientPreferences : _useClientPreferences_ClientPreferences = require("../../relay/__generated__/useClientPreferences_ClientPreferences.graphql"), clientPreferencesRef);
  const {
    discardsBin,
    preferredSupplierId,
    version
  } = prefs || {};
  useEffect(() => {
    const now = Date.now();
    // Fill in preferences
    commitLocalUpdate(getEnvironment(), store => {
      const user = store.getRoot().getLinkedRecord('viewer');
      if (!user || !clientPersistedPreferences) return;

      // Create a unique ID.
      const dataID = `client:Preferences:${viewerId}`;
      // Tell garbage collection to retain the record.

      let records = null;
      if (store.get(dataID)) records = store.get(dataID);else {
        // Create a new clientPreferences record.
        records = store.create(dataID, 'ClientPreferences');
      }

      // Set all none-deep store values
      for (const key of Object.keys(clientPersistedPreferences).filter(item => typeof clientPersistedPreferences[item] !== 'object')) {
        records.setValue(clientPersistedPreferences[key], key);
      }
      // Add the record to the user's list of preferences.
      user.setLinkedRecord(records, 'clientPreferences');
      const clientPreferences = user.getLinkedRecord('clientPreferences');
      if (Array.isArray(clientPersistedPreferences.discardsBin)) {
        // Set list sorting store values
        const clientDiscardedRecords = clientPersistedPreferences.discardsBin.filter(({
          expiryTS
        }) => expiryTS > now) // Filter out expired records
        .map(item => {
          let pref = store.get(item.id);
          if (!pref) {
            //Record does not exist
            //Create a new note record.
            pref = store.create(item.id, 'DiscardedItem');
          }
          for (const key of Object.keys(item)) {
            pref.setValue(item[key], key);
          }
          return pref;
        });

        // Add the record to the user's list of preferences.
        clientPreferences.setLinkedRecords(clientDiscardedRecords, 'discardsBin');
      }
    });
  }, [viewerId, clientPersistedPreferences]);
  return useMemo(() => ({
    preferredSupplierId,
    version,
    discardsBin: discardsBin || []
  }), [discardsBin, preferredSupplierId, version]);
};